export const InfoIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.1875C3.69219 0.1875 0.1875 3.69219 0.1875 8C0.1875 12.3078 3.69219 15.8125 8 15.8125C12.3078 15.8125 15.8125 12.3078 15.8125 8C15.8125 3.69219 12.3078 0.1875 8 0.1875ZM8 3.39062C8.20087 3.39062 8.39723 3.45019 8.56425 3.56179C8.73127 3.67339 8.86144 3.83201 8.93831 4.01759C9.01518 4.20317 9.0353 4.40738 8.99611 4.60439C8.95692 4.8014 8.86019 4.98237 8.71815 5.12441C8.57612 5.26644 8.39515 5.36317 8.19814 5.40236C8.00113 5.44155 7.79692 5.42144 7.61134 5.34456C7.42576 5.26769 7.26714 5.13752 7.15554 4.9705C7.04394 4.80348 6.98437 4.60712 6.98437 4.40625C6.98437 4.13689 7.09138 3.87856 7.28184 3.68809C7.47231 3.49763 7.73064 3.39062 8 3.39062V3.39062ZM10.5 12.2187H5.8125V10.9687H7.53125V7.53125H6.28125V6.28125H8.78125V10.9687H10.5V12.2187Z"
      fill="currentColor"
    />
  </svg>
);
